







































































































































































































import {
  defineComponent,
  onMounted,
  useRouter,
  computed,
  ref,
  watch,
  PropType,
} from "@nuxtjs/composition-api";
import LazyComponent from "v-lazy-component/vue2";
import SkeletonPlaceholder from "~/components/SkeletonPlaceholder.vue";

import { changeImage, getLableSaleColor } from "~/helpers";
import { getConfigurableOptionsByProduct } from "~/modules/catalog/product/helpers";
import {
  getBgColorByVariants,
  getFirstImageByVariants,
  setSizeProductList,
  getUrlQuery,
} from "~/modules/catalog/category/helpers";
import type { Product } from "~/modules/catalog/product/types";
import useProductStock from "~/modules/catalog/product/composables/useProductStock";
import { useCart } from "~/modules/checkout/composables/useCart";
import type { SelectedOption } from "~/modules/catalog/types";
import AddToWishlist from "~/components/AddToWishlist.vue";
import { useUser } from "~/modules/customer/composables/useUser";
import { useAddToCartModal } from "~/composables/useAddToCartModal";
import { getPromotionImageList } from "~/helpers";
import { getPrices } from "~/modules/catalog/product/getters/productGetters";

export default defineComponent({
  name: "CategoryProductCard",
  components: {
    SkeletonPlaceholder,
    LazyComponent,
    AddToWishlist,
  },
  props: {
    product: {
      type: Object as PropType<Product>,
      default: () => ({}),
    },
    classItem: {
      type: String,
      default: "",
    },
    // isDisplayWishlist: {
    //   type: Boolean,
    //   default: false,
    // },
    flashsale: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const imagePromotion = computed(() => {
      if (props.product && props.product.promotion_image_list) {
        return getPromotionImageList(props.product.promotion_image_list);
      }
      return null;
    });

    const labelSale = computed(() => {
      if (props.product && props.product.labels_sales) {
        return getLableSaleColor(props.product.labels_sales);
      }
      return null;
    });

    const { addItem, loading: isLoadingAddToCart } = useCart();
    const { getProductListStock } = useProductStock();
    const hoverAddToCart = ref(false);
    const clicked = ref(false);
    const selectedOption = ref({
      color: null,
      size: null,
    });
    const dataCheckOptionInstock = ref([]);
    const checkCart = ref(false);
    const checkSize = ref(false);
    const checkHover = ref("hover");
    const showMoreColor = ref(false);
    const totalCount = ref(0);
    // const confirmWishlist = ref(false);
    // const pendingWishlistItem = ref(null);

    const productSold = computed(() => {
      return (
        Number(props.product?.saleQty || 0) +
        Number(props.product.fake_qty || 0)
      );
    });
    const { isAuthenticated } = useUser();

    const hoverAddToCartEd = () => {
      hoverAddToCart.value = false;
      clicked.value = false;
    };
    // const { isInWishlist, addOrRemoveItem } = useWishlist();

    const configurableOptions = computed(() => {
      const configurableOpt = props.product?.configurable_options_map || [];

      if (props.product && props.product.first_child_product) {
        const skuColor =
          props.product.first_child_product?.split("-")?.[1] || "";
        const skuSize =
          props.product.first_child_product?.split("-")?.[2] || "";

        return configurableOpt.map((option) => {
          if (option.attribute_code === "color" && skuColor) {
            const optionCopy = { ...option };

            optionCopy.values = [...option.values].sort((a, b) => {
              if (a.label === skuColor) return -1;
              if (b.label === skuColor) return 1;
              return 0;
            });

            return optionCopy;
          }

          if (option.attribute_code === "size" && skuSize) {
            const optionCopy = { ...option };
            optionCopy.values = [...option.values].sort((a, b) => {
              if (a.label === skuSize) return -1;
              if (b.label === skuSize) return 1;
              return 0;
            });

            return optionCopy;
          }

          return option;
        });
      }

      return configurableOpt;
    });

    const availableOptions = computed(() => {
      return getConfigurableOptionsByProduct(configurableOptions.value);
    });

    const variants = computed(() => {
      return props.product?.configurable_children ?? [];
    });

    const skuList = computed(() => {
      return variants.value.map((variant) => variant?.sku);
    });

    const parentSku = computed((): string => {
      if (props.product && props.product.sku) {
        const skuArr = props.product.sku.split("-");
        return skuArr.length > 0 ? skuArr[0] : props.product.sku;
      }
      return "";
    });

    const checkStockBySkus = async () => {
      // if (props.product.type_id === "configurable") {
      const paramSkus = skuList.value
        .map((sku) => encodeURIComponent(sku))
        .join(",");
      dataCheckOptionInstock.value = await getProductListStock(paramSkus);
      checkoption();
      // }
      // else {
      // Xử lý sản phẩm simple
      // }
    };

    const findMatchingVariant = (selectedOption: SelectedOption) => {
      const selectedColor = selectedOption.color;
      const selectedSize = selectedOption.size;
      const configurableOpt = props.product?.configurable_options_map || [];
      const hasColorAttribute = configurableOpt.some(
        (opt) => opt.attribute_code === "color"
      );
      const hasSizeAttribute = configurableOpt.some(
        (opt) => opt.attribute_code === "size"
      );

      return (
        variants.value.find((variant) => {
          const colorMatch =
            !hasColorAttribute ||
            !selectedColor ||
            variant.color?.toString() ===
              selectedColor?.value_index?.toString();

          const sizeMatch =
            !hasSizeAttribute ||
            !selectedSize ||
            variant.size?.toString() === selectedSize?.value_index?.toString();

          if (hasColorAttribute && hasSizeAttribute) {
            return colorMatch && sizeMatch;
          }
          if (hasColorAttribute && !hasSizeAttribute) {
            return colorMatch;
          }
          if (!hasColorAttribute && hasSizeAttribute) {
            return colorMatch;
          }
        }) || null
      );
    };

    const findMatchingSku = (selectedOption: SelectedOption) => {
      return findMatchingVariant(selectedOption)?.sku || null;
    };

    const productShowPrice = computed(() => {
      return findMatchingVariant(selectedOption.value) || props.product;
    });

    const checkoption = () => {
      if (
        !dataCheckOptionInstock.value ||
        dataCheckOptionInstock.value.length < 1
      ) {
        checkCart.value = false;
        return;
      }

      let sku;
      const { color, size } = selectedOption.value;
      if (!color && !size) {
        sku = parentSku.value;
      } else if (color && !size) {
        sku = `${parentSku.value}-${color.label}`;
      } else if (color && size) {
        sku = findMatchingSku(selectedOption.value);
      }
      if (sku) {
        checkSkuInStock(sku);
      }
    };

    const checkSkuInStock = (sku: string) => {
      if (dataCheckOptionInstock.value[sku]) {
        checkCart.value = dataCheckOptionInstock.value[sku]?.is_in_stock;
        totalCount.value = dataCheckOptionInstock.value[sku]?.qty;
      } else {
        totalCount.value = 0;
        for (const key in dataCheckOptionInstock.value) {
          if (dataCheckOptionInstock.value[key].sku.includes(sku)) {
            totalCount.value =
              totalCount.value + dataCheckOptionInstock.value[key]?.qty;
          }
        }
        if (totalCount.value > 0) {
          checkCart.value = true;
        } else {
          checkCart.value = false;
        }
      }
    };

    const sortSizeOptionsByKey = (data) => {
      let options = data;
      let key = "label";
      let defaultSizeText = [
        "XXXS",
        "XXS",
        "XS",
        "S",
        "M",
        "L",
        "XL",
        "XXL",
        "XXXL",
      ];
      let sizeText = [];
      let sizeNumber = [];

      defaultSizeText?.forEach((label, i) => {
        options?.forEach((value, j) => {
          if (label === value[key]) {
            sizeText.push(value);
          }
        });
      });
      options?.forEach((value, i) => {
        let existInDefaultSizeText = false;
        defaultSizeText?.forEach((label, j) => {
          if (value[key] === label) {
            existInDefaultSizeText = true;
          }
        });
        if (!existInDefaultSizeText) {
          sizeNumber.push(value);
        }
      });
      sizeNumber.sort((a, b) => a[key] - b[key]);
      return [...sizeNumber, ...sizeText];
    };

    const isOptionSelected = (attributeOption) => {
      return (
        selectedOption.value[attributeOption.type] &&
        selectedOption.value[attributeOption.type].uid === attributeOption.uid
      );
    };

    const isCheckDisableSize = (size: string) => {
      if (dataCheckOptionInstock.value?.length > 0) {
        let sku =
          parentSku.value +
          (selectedOption.value?.color?.label
            ? "-" + selectedOption.value.color.label
            : "") +
          "-" +
          size;
        let stock = dataCheckOptionInstock.value.find((e) => e.sku === sku);

        if (stock) {
          return stock?.is_in_stock;
        }
      }
      return true;
    };

    const handleChangeOption = (option) => {
      if (!isCheckDisableSize(option.label)) return;
      selectedOption.value[option.type] = option;

      if (dataCheckOptionInstock.value && option.type !== "color") {
        const sku = findMatchingSku(selectedOption.value);

        if (selectedOption.value.color && selectedOption.value.size) {
          const productConfigSku = { ...props.product, sku: sku };
          // handleAddToCart(productConfigSku, 1);
        }
      }
    };

    const handleAddToCart = (product: Product, qty: number) => {
      // if (canAddToCart( product,qty)) {
      addItem({
        product: product,
        quantity: qty,
      });
      selectedOption.value.size = null;
      // }
    };

    // const showWishlistConfirmation = (item) => {
    //   pendingWishlistItem.value = item;
    //   confirmWishlist.value = true;
    // };

    // const confirmWishlistChange = () => {
    //   confirmWishlist.value = false;
    //   pendingWishlistItem.value = null;
    // };

    // const confirmWishlistAction = () => {
    //   if (pendingWishlistItem.value) {
    //     addOrRemoveItem(pendingWishlistItem.value);
    //     confirmWishlist.value = false;
    //     pendingWishlistItem.value = null;
    //   }
    // };

    const getFirstImageBySelectedOptions = computed(() => {
      if (selectedOption.value.color) {
        return getFirstImageByVariants(
          selectedOption.value.color,
          variants.value
        );
      }

      // Trả về ảnh mặc định nếu không tìm thấy
      return props.product &&
        props.product.media_gallery &&
        props.product.media_gallery.length > 0
        ? setSizeProductList(props.product.media_gallery?.[0].image)
        : setSizeProductList(props.product?.thumbnail_url);
    });

    const { openAddToCartModal } = useAddToCartModal();

    // Thay đổi hàm openAddToCartModal
    const handleOpenAddToCartModal = () => {
      openAddToCartModal(props.product, selectedOption.value);
    };

    onMounted(() => {
      const option = availableOptions.value?.color?.[0];
      selectedOption.value[option?.type] = option; // Load trang mặc định chọn màu đầu tiên
    });

    watch(
      () => selectedOption.value.color,
      () => {
        selectedOption.value.size = null;
      }
    );

    watch(
      () => selectedOption.value,
      () => {
        checkoption();
      },
      { deep: true }
    );

    return {
      hoverAddToCartEd,
      hoverAddToCart,
      clicked,
      changeImage,
      getFirstImageBySelectedOptions,
      availableOptions,
      checkStockBySkus,
      dataCheckOptionInstock,
      isLoadingAddToCart,
      checkSize,
      checkHover,
      sortSizeOptionsByKey,
      isOptionSelected,
      handleChangeOption,
      isCheckDisableSize,
      getBgColorByVariants,
      showMoreColor,
      handleAddToCart,
      checkCart,
      // isInWishlist: computed(() => isInWishlist({ product: props.product })),
      isAuthenticated,
      // addItemToWishlist: addOrRemoveItem,
      // showWishlistConfirmation,
      // confirmWishlist,
      // confirmWishlistChange,
      // confirmWishlistAction,
      openAddToCartModal: handleOpenAddToCartModal,
      variants,
      imagePromotion,
      labelSale,
      productSold,
      getPrices,
      productShowPrice,
      getUrlQuery,
      selectedOption,
    };
  },
});
